 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		2: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		2: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/chunks/" + ({"0":"framework","8":"5171e4b7dc6a9489934a3b3a9108ea4609f86556","10":"1e7ff48b194f5deab373f5fe4e57ef95f6dc9b56","11":"76d22f9e","12":"bee240a3","13":"f196061c","14":"93a7a566f080877604dc02ec417deb0e5181fcef","25":"966e29d5","31":"eabe11fc","35":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","36":"styles","38":"3d9476d3","39":"4af37035","125":"reactPlayerDailyMotion","126":"reactPlayerFacebook","127":"reactPlayerFilePlayer","128":"reactPlayerKaltura","129":"reactPlayerMixcloud","130":"reactPlayerPreview","131":"reactPlayerSoundCloud","132":"reactPlayerStreamable","133":"reactPlayerTwitch","134":"reactPlayerVidyard","135":"reactPlayerVimeo","136":"reactPlayerWistia","137":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"4f0f880714794e16be83","8":"83ca917c3a23b835767e","10":"1338cece74b70ad2e49c","11":"8775f6be35d736376afc","12":"5d15ec691b2523706afd","13":"f57be764c7698a5bcb03","14":"40bb320e3a485251b65c","25":"1081b9caea8882fa8920","31":"94540108b89061c437a6","32":"7972f33300e5d06bece8","35":"92676630593475d1cab0","36":"034de57766ff36fd46b3","37":"4ba7a64ae5c158d5ecb5","38":"12f9886da68c416ed953","39":"2980bacf0282fb885198","125":"e38a650dcbc842597cc9","126":"f66e0914ca5b0256e9ec","127":"dac14e9d1f1cd8affb68","128":"3c069e3861d2c5d5c2cb","129":"f98ee3aeb2833e7411f0","130":"0d28e0f0d37f5b7a5016","131":"bcf39c203fa22f49a1c0","132":"e4b3450a8e68a83181a2","133":"9dc0e3a7c34c5b4a74c0","134":"36dc4020cf5448b45542","135":"0b2faf06614635c175a1","136":"efccc2f8399e11e1acb6","137":"95bbdded90d39bd1f2ab","138":"842b42d08c272e89d29b","139":"54f5e1452d2af63de714","140":"b2091cb49bb91e449b73","141":"08039aedc95a2f2fe5b2","142":"8d6b3e8d04d8651b7051","143":"0484c2957f0fa542ad8f","144":"7c3fed765461c47e1074","145":"0d4584f49e94c1accac6","146":"b94ef7c8a6d548b24cec"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		var threw = true;
 		try {
 			modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
 			threw = false;
 		} finally {
 			if(threw) delete installedModules[moduleId];
 		}

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"36":1,"138":1,"139":1,"140":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"0":"framework","8":"5171e4b7dc6a9489934a3b3a9108ea4609f86556","10":"1e7ff48b194f5deab373f5fe4e57ef95f6dc9b56","11":"76d22f9e","12":"bee240a3","13":"f196061c","14":"93a7a566f080877604dc02ec417deb0e5181fcef","25":"966e29d5","31":"eabe11fc","35":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","36":"styles","38":"3d9476d3","39":"4af37035","125":"reactPlayerDailyMotion","126":"reactPlayerFacebook","127":"reactPlayerFilePlayer","128":"reactPlayerKaltura","129":"reactPlayerMixcloud","130":"reactPlayerPreview","131":"reactPlayerSoundCloud","132":"reactPlayerStreamable","133":"reactPlayerTwitch","134":"reactPlayerVidyard","135":"reactPlayerVimeo","136":"reactPlayerWistia","137":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","8":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","25":"31d6cfe0","31":"31d6cfe0","32":"31d6cfe0","35":"31d6cfe0","36":"82fcd5fa","37":"31d6cfe0","38":"31d6cfe0","39":"31d6cfe0","125":"31d6cfe0","126":"31d6cfe0","127":"31d6cfe0","128":"31d6cfe0","129":"31d6cfe0","130":"31d6cfe0","131":"31d6cfe0","132":"31d6cfe0","133":"31d6cfe0","134":"31d6cfe0","135":"31d6cfe0","136":"31d6cfe0","137":"31d6cfe0","138":"c72ade17","139":"c72ade17","140":"c72ade17","141":"31d6cfe0","142":"31d6cfe0","143":"31d6cfe0","144":"31d6cfe0","145":"31d6cfe0","146":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
